export class CityList {
    public Code: string;
    public Name: string;
    public selecionado: boolean;
}
